'use es6';

import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PivotTableChartIcon = ({
  size = 25
}) => {
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx("svg", {
      width: size,
      height: size,
      viewBox: "0 0 22 21",
      children: /*#__PURE__*/_jsxs("g", {
        fill: "none",
        fillRule: "evenodd",
        children: [/*#__PURE__*/_jsx("rect", {
          width: "5.833",
          height: "5.833",
          fill: "#BDAAEA"
        }), /*#__PURE__*/_jsx("polygon", {
          fill: "#FEA58E",
          points: "0 8.167 5.833 8.167 5.833 21 0 21"
        }), /*#__PURE__*/_jsx("polygon", {
          fill: "#99ACC2",
          points: "15.212 11.68 18.114 8.127 21.026 11.68 19.386 11.68 19.386 19.259 11.667 19.259 11.667 20.964 8.149 18.119 11.667 15.172 11.667 17.007 16.955 17.007 16.955 11.68"
        }), /*#__PURE__*/_jsx("rect", {
          width: "12.833",
          height: "5.833",
          x: "8.167",
          fill: "#51D3D9"
        })]
      })
    })
  });
};
PivotTableChartIcon.propTypes = {
  size: PropTypes.number
};
export default PivotTableChartIcon;